module.exports = require("lodash/isError");


//////////////////
// WEBPACK FOOTER
// external "lodash/isError"
// module id = 124
// module chunks = 0 1